export default {
  messages: {
    en: {
      descriptions: {
        default: {
          f: '{name} needs <strong>{amount}</strong>, will you help her reach her target?',
          group: '{name} need <strong>{amount}</strong>, will you help them reach their target?',
          m: '{name} needs <strong>{amount}</strong>, will you help him reach his target?',
        },
        defaulted: 'Unfortunately, this loan has been defaulted.',
        finished: {
          group: '{name} have repaid the loan of <strong>{amount}</strong>.',
          individual: '{name} has repaid the loan of <strong>{amount}</strong>.',
        },
        devalued: {
          group: '{name} have repaid the loan of <strong>{amount}</strong>.',
          individual: '{name} has repaid the loan of <strong>{amount}</strong>.',
        },
        funded: '{name} loan of <strong>{amount}</strong> is fully funded.',
      },
      quickLend: {
        added: '{amount} loan added to basket',
        checkout: 'Proceed to checkout &gt;',
        entireRemaining: 'Entire amount',
        submit: 'Lend',
        undo: 'Undo',
      },
      requested: 'Requested',
      viewDetails: 'View loan details',
    },
  },
}
